import { get } from 'lodash-es';
import { CookieService } from '../services/cookie-service';
import * as Cookies from '../constants/cookies';

const V2_SUB_DOMAIN_PREPEND = 'ss';
const V3_SUB_DOMAIN_PREPEND = 'ship';
const REDIRECT_ROUTE_PATH = '/app-redirect';
const LOCAL_V3_PORT = ':2999';
const LOCAL_V2_PORT = ':3000';
const DYNAMIC_V2_PREPEND = 'v2-';
const DYNAMIC_V3_PREPEND = 'v3-';
const PREFERRED_VERSION_KEY_NAME = 'CurrentUIVersion';
const IS_NATIVE_V3_KEY_NAME = 'IsNativeV3Seller';
const defaultLandingSpot = '/#/orders';
const localhostSubdomains = ['localhost', '127.0.0.1'];
// set this to true to allow the switch over when running v2 and v3 locally
const isTestingUiSwitchLocal = false;
const v2ToV3LandingSpot = [
  {
    v3Origin: '/dashboard',
    v2Destination: '/#/dashboard',
  },
  {
    v3Origin: '/orders',
    v2Destination: defaultLandingSpot,
  },
  {
    v3Origin: '/shipments',
    v2Destination: '/#/track/shipments',
  },
  {
    v3Origin: '/products',
    v2Destination: '/#/products',
  },
  {
    v3Origin: '/customers',
    v2Destination: '/#/customers',
  },
];

// using a v3 origin regex, create a v2 destination using capture group
// this prevents the need for an entry for every marketplace id
const v2ToV3ComputedLandingSpot = [
  {
    v3OriginRegex: /settings\/stores\/setup\/(\d+)/,
    v2Destination: '/#/settings/stores/setup/<capture>',
  },
];

class UserInterfaceServiceClass {
  getSubDomain(stringToCompare) {
    if (stringToCompare && stringToCompare.length && stringToCompare.split('.').length > 0) {
      return stringToCompare.split('.')[0];
    }
  }

  getRedirectHostForV2UserAccessingV3() {
    const siteHost = window.location.host;
    return this.getCorrectedSubDomainHostForV2User(siteHost);
  }

  getCorrectedSubDomainHostForV2User(siteHost) {
    const siteHostParts = siteHost.split('.');
    siteHostParts[0] = siteHostParts[0].replace(V3_SUB_DOMAIN_PREPEND, V2_SUB_DOMAIN_PREPEND);
    return siteHostParts.join('.');
  }

  getRedirectLandingSpot(v3Url) {
    const computedLandingSpot = v2ToV3ComputedLandingSpot.find((v2Check) => v2Check.v3OriginRegex.test(v3Url));
    if (computedLandingSpot) {
      const result = computedLandingSpot.v3OriginRegex.exec(v3Url);
      const capture = result[1];
      return computedLandingSpot.v2Destination.replace('<capture>', capture);
    }

    const foundLandingSpot = v2ToV3LandingSpot.find((v2Check) => v3Url.includes(v2Check.v3Origin));
    if (foundLandingSpot) {
      return foundLandingSpot.v2Destination;
    }
    return defaultLandingSpot;
  }

  getRedirectRoute() {
    let redirectHost = this.getRedirectHostForV2UserAccessingV3();
    const landingSpot = this.getRedirectLandingSpot(window.location.href);
    // local dev support
    if (redirectHost && redirectHost.includes(LOCAL_V3_PORT)) {
      redirectHost = redirectHost.replace(LOCAL_V3_PORT, LOCAL_V2_PORT);
    }
    // dynamic environment support
    if (redirectHost && redirectHost.includes(DYNAMIC_V3_PREPEND)) {
      redirectHost = redirectHost.replace(DYNAMIC_V3_PREPEND, DYNAMIC_V2_PREPEND);
    }
    return `${window.location.protocol}//${redirectHost}${landingSpot}`;
  }

  getRedirectRoutePath() {
    return REDIRECT_ROUTE_PATH;
  }

  getPreferredUiSettingName() {
    return PREFERRED_VERSION_KEY_NAME;
  }

  getDefaultLandingSpot() {
    return defaultLandingSpot;
  }

  sendUserToV2() {
    // Prevent infinite redirection between v3 and v2 -> Set new home to v2
    const currentSSHome = CookieService.getCookieValue(Cookies.SSHome);
    const newSSHome = this.getCorrectedSubDomainHostForV2User(currentSSHome);
    CookieService.removeCookie(Cookies.SSHome);
    CookieService.setCookieValueWithExpiration(Cookies.SSHome, newSSHome, 365 * 2);

    // Special cookie to let the Auth0 Session know that the user home claim in the AT has changed
    // Doesn't matter if user did not use Auth0
    CookieService.setCookieValueWithExpiration(Cookies.Auth0PartitionHostChanged, newSSHome, 365 * 2);
    const redirectRoute = this.getRedirectRoute();
    setTimeout(() => {
      window.location.href = redirectRoute;
    }, 1);
  }

  isUserPreferredUiVersion2(userSettings) {
    const uiPreferenceSetting = userSettings.find((setting) => setting.settingName === PREFERRED_VERSION_KEY_NAME);
    return uiPreferenceSetting && get(uiPreferenceSetting, 'settingValue', '').toLowerCase() === 'v2';
  }

  isRunningLocally(redirectHost = this.getRedirectHostForV2UserAccessingV3()) {
    if (isTestingUiSwitchLocal) {
      return false;
    }
    return localhostSubdomains.some((subdomain) => redirectHost.includes(subdomain));
  }

  isV3Native(sellerSettings) {
    return get(sellerSettings, IS_NATIVE_V3_KEY_NAME, 'false') === 'true';
  }
}

export const UserInterfaceService = new UserInterfaceServiceClass();
